import script from "./AutocompleteSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./AutocompleteSelect.vue?vue&type=script&setup=true&lang=js"

import "./AutocompleteSelect.vue?vue&type=style&index=0&id=5260cd80&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5260cd80"]])

export default __exports__